import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { Button } from '@mui/material';
import DashEmbalagemSemanaDialog from '../DashEmbalagemSemanaDialog';
import { calcularTamanhoFonte } from '../../../utils/fontSize';
import api from '../../../services/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(valor);
};

const Dashboard = ({ isPaused, setIsPaused }) => {

    const [dados, setDados] = useState([]);
    const [dadosDialog, setDadosDialog] = useState([]);
    const [modalAberto, setModalAberto] = useState(false);
    const [produtoSelecionado, setProdutoSelecionado] = useState('');
    const [produtoDescricaoSelecionado, setProdutoDescricaoSelecionado] = useState('');

    useEffect(() => {
        api.get('/embalagemsemana_dash')
            .then(response => setDados(response.data))
            .catch(error => console.error('Erro ao carregar os dados:', error));
    }, []);

    useEffect(() => {
        api.get('/embalagemsemana_detalhado')
            .then(response => setDadosDialog(response.data))
            .catch(error => console.error('Erro ao carregar os dados:', error));
    }, []);

    function abrirModal() {
        setModalAberto(true);
        setIsPaused(true);
    }

    function fecharModal() {
        setModalAberto(false);
        // setIsPaused(false);
    }

    const vendasMeta = dados.Meta || 0;
    const vendasProgramado = dados.Programado || 0;
    const vendasEmbalado = dados.Embalado || 0;

    const chartData = {
        labels: ['EMBALAGEM'],
        datasets: [
            {
                label: 'PROGRAMADO',
                data: [vendasProgramado],
                backgroundColor: ['#1976d2',]
            },
            {
                label: 'EMBALADO',
                data: [vendasEmbalado],
                backgroundColor: ['#26a69a']
            },
            {
                label: 'META',
                data: [vendasMeta],
                backgroundColor: ['#860997FF']
            }
        ]
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('label')
                    }
                }
            },
            datalabels: {
                anchor: 'end',
                align: 'bottom',
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: calcularTamanhoFonte('datalabel')
                },
                formatter: (value) => formatarValor(value)
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('scales')
                    }
                },
                grid: { color: '#444' }
            },
            y: {
                ticks: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('scales')
                    }
                },
                grid: { color: '#444' }
            }
        }
    };

    return (
        <div>
            <h1>Embalagem da Semana</h1>
            <div style={{ height: '80vh', overflow: 'hidden', padding: '20px', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Bar data={chartData} options={chartOptions} sx={{ mb: 2 }} />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                <Button variant="contained" color="success" onClick={abrirModal} style={{ marginTop: '20px' }}>
                    📊 Detalhes da embalagem
                </Button>
            </div>

            <DashEmbalagemSemanaDialog
                open={modalAberto}
                onClose={fecharModal}
                dados={dadosDialog}
                produtoSelecionado={produtoSelecionado}
                setProdutoSelecionado={setProdutoSelecionado}
                produtoDescricaoSelecionado={produtoDescricaoSelecionado}
                setProdutoDescricaoSelecionado={setProdutoDescricaoSelecionado}
            />

        </div >
    );
};

export default Dashboard;
